module.exports = __webpack_public_path__ + "static/media/1.Knapsack Sprayer.9ccede14.jpg";